// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.au-table-container {
  overflow-x: auto;
}

.au-table {
  width: 100%;
}

.v-align-middle {
  vertical-align: middle;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/dispute-resolution/public-view-administrative-units-list/public-view-administrative-units-list.component.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;AACF;;AAEA;EACE,WAAA;AACF;;AAEA;EACE,sBAAA;AACF","sourcesContent":[".au-table-container {\r\n  overflow-x: auto;\r\n}\r\n\r\n.au-table {\r\n  width: 100%;\r\n}\r\n\r\n.v-align-middle {\r\n  vertical-align: middle;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
